import { Typography } from 'antd';
import React from 'react';

import { COLOR } from '../../theme/tokens';
import { formatEur } from './labels';

const { Text } = Typography;

function ProfitText({ value }: { value: number | null }): React.ReactElement {
  if (value === null) {
    return <Text type="secondary">{formatEur(value)}</Text>;
  }

  return (
    <Text strong style={{ color: value >= 0 ? COLOR.success : COLOR.error }}>
      {formatEur(value)}
    </Text>
  );
}

export default ProfitText;
